/**
 * Smooth Scroll when click on link
 * @dependencies jump.js
 * @dependencies ez.js
 */

import Jump from 'jump.js'
import { easeInOutQuad } from 'ez.js';

const links = document.getElementsByClassName('js-smooth-scroll');
const headerEl = document.querySelector('.js-fixed-header');
let headerHeight;

if(headerEl) {
  headerHeight = headerEl.offsetHeight;
}

for (let index = 0; index < links.length; index++) {
  const el = links[index];
  const url = el.getAttribute('href');
  const hash = url.substring(url.indexOf('#') + 1);
  const duration = el.getAttribute('data-jump-duration') ? el.getAttribute('data-jump-duration') : 800;

  el.addEventListener('click', (ev) => {
    ev.preventDefault();
    Jump(`#${hash}`, {
      duration: duration,
      easing: easeInOutQuad,
      offset: -headerHeight,
    });
  });
}
